(function () {
  var cfg = window.theme && window.theme.lopRewardsSwap;
  if (!cfg || cfg.enabled !== true) return;

  var productIds = new Set((cfg.productIds || []).map(Number).filter(function (id) {
    return id > 0;
  }));

  if (!productIds.size) return;

  var allowSubmit = false;

  function cartIsBlocked(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    return cart.items.every(function (item) {
      return productIds.has(Number(item.product_id));
    });
  }

  function isCheckoutLink(link) {
    if (!link || link.tagName !== 'A') return false;
    var href = link.getAttribute('href') || '';
    return href === '/checkout' || /\/checkout(?:\?|#|$)/.test(href);
  }

  function showBlocked(control) {
    var host = control && control.closest('#pinnacle-cart-buttons, .thb-cart-form--proceed, .pinnacle-cart-footer');
    if (!host) host = control && control.parentElement;
    if (!host) return;

    host.classList.add('lop-rewards-swap-blocked');
    host.setAttribute('data-lop-rewards-swap-blocked', 'true');

    if (!host.querySelector('.lop-rewards-swap-notice')) {
      var notice = document.createElement('p');
      notice.className = 'lop-rewards-swap-notice';
      notice.setAttribute('role', 'status');
      notice.textContent = cfg.message || '';
      host.insertBefore(notice, host.firstChild);
    }

    host.querySelectorAll('a[href*="/checkout"], button[name="checkout"], .checkout-button').forEach(function (button) {
      if (button.tagName === 'A') {
        var replacement = document.createElement('button');
        replacement.type = 'button';
        replacement.className = button.className;
        replacement.disabled = true;
        replacement.setAttribute('aria-disabled', 'true');
        replacement.setAttribute('data-lop-rewards-swap-blocked', 'true');
        replacement.textContent = button.textContent;
        button.replaceWith(replacement);
      } else {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-lop-rewards-swap-blocked', 'true');
      }
    });

    host.querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons').forEach(function (extra) {
      extra.hidden = true;
    });
  }

  function verifyCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) { return cartIsBlocked(cart); });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a');
    if (!isCheckoutLink(link)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    event.preventDefault();
    event.stopPropagation();

    verifyCart()
      .then(function (blocked) {
        if (blocked) {
          showBlocked(link);
          return;
        }
        window.location.href = link.href;
      })
      .catch(function () {
        window.location.href = link.href;
      });
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'cart-form') return;
    if (allowSubmit) {
      allowSubmit = false;
      return;
    }

    var submitter = event.submitter;
    if (submitter && submitter.name && submitter.name !== 'checkout') return;

    event.preventDefault();

    var control = submitter || form.querySelector('button[name="checkout"]') || form;

    verifyCart()
      .then(function (blocked) {
        if (blocked) {
          showBlocked(control);
          return;
        }
        allowSubmit = true;
        if (submitter && typeof submitter.click === 'function') {
          submitter.click();
        }
      })
      .catch(function () {
        allowSubmit = true;
        if (submitter && typeof submitter.click === 'function') {
          submitter.click();
        }
      });
  }, true);
})();
